import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";
import DrawerHeaderStyled from "./DrawerHeaderStyled";
import { DoubleRightOutlined } from '@ant-design/icons';
import { HEADER_HEIGHT } from "config";
import egslogo from "assets/images/images/esglogo.svg";

const DrawerHeader = ({ open, setOpen }) => {
  const theme = useTheme();

  const iconStyle = {
    fontSize: '28px',
    color: '#ffffff',
    cursor: 'pointer',
    transition: 'color 0.3s ease',
    display: 'flex',
  };

  const HandleHamBurgerOnclicks = () => {
    setOpen(true);
  };

  return (
    <DrawerHeaderStyled
      theme={theme}
      open={open}
      sx={{
        backgroundColor: "#ffffff",
        borderBottom: "3px solid #FEC700",
        minHeight: HEADER_HEIGHT,
        width: "inherit",
        paddingTop: "8px",
        paddingBottom: "8px",
        paddingLeft: open ? "18px" : 0,
        paddingRight: open ? "16px" : 0,
        display: "flex",
        alignItems: "center",
        justifyContent: open ? "flex-start" : "center",
      }}
    >
      {open ? (
        <>
          <Box
            component="img"
            src={egslogo}
            alt="ESG Vision"
            sx={{ height: 32, width: "auto", flexShrink: 0 }}
          />
        </>
      ) : (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            height: "100%",
          }}
        >
          <DoubleRightOutlined
            onClick={HandleHamBurgerOnclicks}
            style={{ ...iconStyle, color: "#02462E" }}
            onMouseEnter={e => (e.currentTarget.style.color = '#FEC700')}
            onMouseLeave={e => (e.currentTarget.style.color = '#02462E')}
          />
        </Box>
      )}
    </DrawerHeaderStyled>
  );
};

DrawerHeader.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
};

export default DrawerHeader;